/**
 * Browser-spezifische Audio-Aufnahme (MediaRecorder) + Whisper-kompatible Dateinamen.
 * Safari/iOS unterstützt oft kein audio/webm;codecs=opus.
 */

export function pickMediaRecorderMime(): { mimeType?: string; blobFallback: string; fileExt: string } {
  const candidates: { mime: string; blob: string; ext: string }[] = [
    { mime: 'audio/webm;codecs=opus', blob: 'audio/webm', ext: 'webm' },
    { mime: 'audio/webm', blob: 'audio/webm', ext: 'webm' },
    { mime: 'audio/mp4', blob: 'audio/mp4', ext: 'm4a' },
    { mime: 'audio/ogg;codecs=opus', blob: 'audio/ogg', ext: 'ogg' },
    { mime: 'audio/wav', blob: 'audio/wav', ext: 'wav' },
  ];
  if (typeof MediaRecorder !== 'undefined') {
    for (const c of candidates) {
      if (MediaRecorder.isTypeSupported(c.mime)) {
        return { mimeType: c.mime, blobFallback: c.blob, fileExt: c.ext };
      }
    }
  }
  return { blobFallback: 'audio/webm', fileExt: 'webm' };
}

/** Dateiname für OpenAI Whisper / multipart (Extension passend zum Blob-Typ). */
export function whisperUploadName(blob: Blob, base: string): string {
  const t = blob.type || '';
  if (t.includes('mp4')) return `${base}.m4a`;
  if (t.includes('ogg')) return `${base}.ogg`;
  if (t.includes('wav')) return `${base}.wav`;
  if (t.includes('mpeg') || t.includes('mp3')) return `${base}.mp3`;
  return `${base}.webm`;
}
